import { SMIME_INSTALLED_HEADER_KEY, SMIME_INSTALLED_HEADER_TRUE } from '../utils/constants';
import { isSuccessStatusCode } from 'owa-http-status-codes';

const CONTENT_TYPE_KEY = 'Content-Type';
const CONTENT_TYPE_VALUE = 'application/json;charset=utf-8';

/**
 * Fetches the content of a file in data:multipart/signed;base64 format
 */
const fetchWithSmimeHeaders = async (url: string): Promise<string> => {
    const requestInit: RequestInit = {};
    requestInit.method = 'GET';
    requestInit.headers = new Headers();
    (<Headers>requestInit.headers).set(SMIME_INSTALLED_HEADER_KEY, SMIME_INSTALLED_HEADER_TRUE);
    (<Headers>requestInit.headers).set(CONTENT_TYPE_KEY, CONTENT_TYPE_VALUE);
    const filePromise: Response = await fetch(url, requestInit);
    if (!isSuccessStatusCode(filePromise.status)) {
        throw new Error(`The data package cannot be retrieved. StatusCode: ${filePromise.status}`);
    }
    const data = await filePromise.text();
    return data;
};

export default fetchWithSmimeHeaders;
